export const MULTIPLY = 'multiply';
export const DIVIDE = 'divide';
export const ADD = 'add';
